module.exports = __webpack_public_path__ + "media/images/about-us/works/Confirmation and Itinerary Sent Image_Updated-1321abf6d0a5fa83098646abb162d3c8.png";